import { observable, makeObservable } from 'mobx';
import {DomainObject} from 'shared/store';
import Employee from 'main/stores/employees/Employee';
import CompanyDocument from 'main/stores/documents/CompanyDocument';

class CompanyDocumentAssignment extends DomainObject {
  id;
  companyDocument;
  selectAllEmployees = false;
  employees = [];
  dueDate;

  _relations = {
    companyDocument: CompanyDocument,
    employees: [Employee]
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      companyDocument: observable,
      selectAllEmployees: observable,
      employees: observable,
      dueDate: observable
    });

    this.merge(other);
  }
}

export default CompanyDocumentAssignment;
